/*
XCLUSIVE SPEED OPTIMIZED JS — SAFE ULTRA VERSION
*/

(function () {

if (window.__XCLUSIVE_SPEED_LOADED__) return;
window.__XCLUSIVE_SPEED_LOADED__ = true;

const runIdle = window.requestIdleCallback || function(cb){setTimeout(cb,1)};

/* IMAGE OPTIMIZATION */
function optimizeImages(){

const imgs = document.querySelectorAll('img');

imgs.forEach((img,i)=>{

if(!img.hasAttribute('decoding'))
img.decoding = 'async';

/* skip first images (LCP) */
if(i>2 && !img.hasAttribute('loading'))
img.loading = 'lazy';

});

}

/* CLEAN UNUSED ATTRIBUTES */
function cleanup(){

document.querySelectorAll('[data-src]').forEach(el=>{
if(el.dataset.src && !el.src){
el.src = el.dataset.src;
}
});

}

/* RUN */
function init(){

runIdle(()=>{
optimizeImages();
cleanup();
});

}

if(document.readyState !== 'loading') init();
else document.addEventListener('DOMContentLoaded', init, {once:true});

})();





